var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('b-row',[_c('b-col',[_c('h1',[_vm._v("Author TTS")])])],1),_c('b-row',[_c('b-col',[_c('b-button',{on:{"click":_vm.confirmAuthorTts}},[_vm._v("Confirm Author TTS")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }